import { useRef, useEffect } from 'react';
import { useQuery } from 'react-query';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Messages } from 'primereact/messages';
import { Button } from 'primereact/button';
import { AxiosError } from 'axios';
import { getAllGrants } from '../../../services/acl';
import { TitleWrapper } from '../../Headings/common';
import { PageTitle } from '../../Headings';
import { useRefreshGrantSeeds } from '../../../services/mutations';
import { getAxiosError } from '../../../utils/axiosError';

function GrantList() {
  const { data, isFetching, error } = useQuery('grantList', getAllGrants);
  const refreshSeeds = useRefreshGrantSeeds();
  const messages = useRef<Messages>(null);

  const handleRefreshSeeds = () => {
    refreshSeeds.mutate(undefined, {
      onError: (err: any) => {
        messages.current?.show({ severity: 'error', summary: getAxiosError(err), sticky: true, closable: true });
      },
    });
  };

  useEffect(() => {
    if (error) {
      messages.current?.show({ severity: 'error', summary: 'An error has occurred while loading data!', sticky: true });
    }
  }, [error]);

  return (
    <div>
      <Messages ref={messages} />
      <TitleWrapper>
        <PageTitle>Grant List</PageTitle>
        <div>
          <Button
            icon="pi pi-refresh"
            size="small"
            label="Refresh seeds"
            loading={refreshSeeds.isLoading}
            onClick={handleRefreshSeeds}
          />
        </div>
      </TitleWrapper>
      <DataTable loading={isFetching} value={data} rows={15} size="small" rowHover paginator>
        <Column header="ID" field="id" sortable />
        <Column header="Grant Name" field="name" sortable />
      </DataTable>
    </div>
  );
}

export default GrantList;
